<template>

    <div class="card">
        <div class="card-body">
            <h5 class="card-title">{{ title }}</h5>
            <slot />
        </div>
    </div>

</template>

<script>
    export default {
        props: {
            title: String,
        }
    }
</script>

<style scoped>

</style>
